import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const SelfStatsScorad = ({ score, startDate, endDate }) => {
  const getDatesInRange = (start, end) => {
    const dates = [];
    let cur = new Date(start);
    while (cur <= end) {
      dates.push(cur.toISOString().split("T")[0]);
      cur.setDate(cur.getDate() + 1);
    }
    return dates;
  };

  const categories = useMemo(() => getDatesInRange(startDate, endDate), [startDate, endDate]);

  const seriesData = useMemo(() => {
    return categories.map((date) => {
      const match = (score || []).find((s) => s.logDate && s.logDate.startsWith(date));
      return match ? parseFloat(match.scoradScore || 0) : null;
    });
  }, [score, categories]);

  const options = {
    chart: { type: "line", height: 220, margin: [10, 0, 50, 50], backgroundColor: "rgba(0,0,0,0)" },
    title: { text: "" },
    credits: { enabled: false },
    xAxis: {
      categories,
      labels: {
        style: { fontSize: "10px" },
        formatter() { const d = new Date(this.value); return `${d.getDate()} ${d.toLocaleString("default",{month:"short"})}`; },
      },
      lineWidth: 0,
    },
    yAxis: { title: { text: "SCORAD" }, gridLineDashStyle: "dot", gridLineColor: "#646464" },
    plotOptions: { line: { dataLabels: { enabled: true }, color: "#35b400" } },
    series: [{ name: "SCORAD", data: seriesData, showInLegend: false, color: "#35b400" }],
    legend: { enabled: false },
  };

  return (
    <div className="selfstats-box">
      <h2 className="selfstats-title">SCORAD</h2>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

SelfStatsScorad.defaultProps = { score: [], startDate: new Date(), endDate: new Date() };

export default SelfStatsScorad;
